<!-- Global Progress Bar for loading sessions -->
<div *ngIf="sessionService.isLoadingSessions$ | async" class="loading-indicator">
  <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
</div>

<div class="card surface-ground border-round full-height-container">
  <div *ngIf="(sessionService.initialLoadComplete$ | async) && sessions.length === 0" class="no-sessions-message p-p-3">
    <p>No active sessions. Click "Add New Session" to get started.</p>
  </div>
  <p-tabs #tabs *ngIf="sessions.length > 0" scrollable [(value)]="activeSessionId">
    <p-tablist class="surface-ground">
      @for (session of sessions; track session.sessionId) {
      <p-tab *ngIf="!session.resource" [value]="session.sessionId" [routerLink]="getRouterLink(session)">
        <p-avatar *ngIf="session.users.length == 2" image="assets/technical_support.png" />
        <p-avatar-group *ngIf="session.users.length > 2">
          <p-avatar *ngFor="let user of session.users; index as i" [image]="user.profilePictureUrl" shape="circle"
            [pTooltip]="user.fullName" />
        </p-avatar-group>
        <span>Session# {{ session.sessionId }}</span>
        <p-button icon="pi pi-times" size="small" [rounded]="true" [text]="true" severity="danger"
          (click)="onTabClose($event, session)" />
      </p-tab>
      <p-tab *ngIf="session.resource" [value]="session.sessionId" [routerLink]="getRouterLink(session)">
        <i [class]="session.resource.icon"></i>
        <span>{{ session.title }}</span>
        <p-avatar-group>
          <p-avatar *ngFor="let user of session.users; index as i" [image]="user.profilePictureUrl" shape="circle"
            [pTooltip]="user.fullName" />
        </p-avatar-group>
        <p-button icon="pi pi-times" size="small" [rounded]="true" [text]="true" severity="danger"
          (click)="onTabClose($event, session)" />
      </p-tab>
      }
    </p-tablist>
  </p-tabs>
  <div class="pt-2 router-outlet-container">
    <router-outlet></router-outlet>
  </div>
</div>